<template>
    <div class="container">
        <v-card>
            <v-card-title class="titulopagina">ALARMAS</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="6" sm="3">
                        <date-picker class="dtpicker" v-model="fecha" @change="cargarDatos" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                    </v-col>
                    <v-col cols="6" sm="3">
                        <v-btn @click="download" outlined color="green">Excel</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-data-table 
            :headers="cabeceras"
            :items="lista"
            class="elevation-1"
            dense
        >
        </v-data-table>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex'
//import Tabla from '@/components/shared/Tabla.vue'
import Data_Table from '@/components/shared/Data_Table.vue'
import Modal from '@/components/shared/Modal.vue'
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
// import axios from 'axios'
export default {
    data:()=>({
        fecha: new Date().toISOString().substr(0, 10),
        mostrar_fecha: false,
        lista:[],
        url_excel: '',
        show_excel: false,
        inputs:[
            {tipo:'texto',valor:'',label:'Unidad de Medida*',key:'unidad_medida'},
            {tipo:'texto',valor:'',label:'Nombre Corto*',key:'nombre_corto'}
        ],
        configuracion_modal:{
            titulo_modal:'',
            boton_submit:'',
            ruta:'',
            tipo_peticion:''
        },
        //configuracion para datatable
        cabeceras:[
            {
                text:'Fecha Hora',
                align:'center',
                sortable:true,
                filterable:true,
                value:'fecha_hora',
                class:"cabecera"
            },
            {
                text:'Punto de medicion',
                align:'center',
                sortable:true,
                filterable:true,
                value:'punto_medicion',
                class:"cabecera"
            },
            {
                text: 'Equipo',
                align: 'center',
                sortable: true,
                value: 'equipo_proceso',
                class:"cabecera",
            },
            {
                text: 'Parametro',
                align: 'center',
                sortable: true,
                value: 'parametro',
                class:"cabecera",
            },
            {
                text: 'Unidad medida',
                align: 'center',
                sortable: true,
                value: 'unidad_medida',
                class:"cabecera",
            },
            {
                text: 'Valor',
                align: 'center',
                sortable: true,
                value: 'valor',
                class:"cabecera",
            },
        ],
        acciones:[
            {key:'editar',titulo:'Editar',visible:true}
        ]
    }),
    created() {
        // Event.$on('peticion_realizada',()=>{
        //     this.cargarDatos()
        // })
    },
    mounted() {
        this.cargarDatos()
    },
    methods: {
        async cargarDatos(){
            this.url_excel = '';
            //this.mostrarLoading('Cargando Datos...');
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}alarmas/dia/${this.fecha}`;
            await this.axios.get(url,this.headers).then((response)=>{
                let resp = response.data.data
                this.lista = resp.resultados;
                this.url_excel = resp.url_excel;
                this.ocultarLoading();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            })
        },
        download(){
            window.location.href = this.url_excel;
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers']),

        fecha_formateada () {
          return this.fecha ? this.moment(this.fecha).format('DD-MM-YYYY') : '';
        }
    },
    components:{
        'modal':Modal,
        'data-table':Data_Table,
        DatePicker
    }
}
</script>
<style scoped>
    .mx-datepicker{
        width: 100% !important;
    }
</style>